import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerService } from 'api';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
export default function useCustomerAddress() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    t
  } = useTranslation();
  const {
    customer,
    setCustomer
  } = useCurrentCustomer();
  const changeAddress = async (addressType, address) => {
    if (!customer) return;
    try {
      setIsLoading(true);
      const customerBody = {
        ...customer,
        [addressType]: address
      };
      if (customer.id) {
        const customerObject = await CustomerService.editCustomer({
          customerId: customer.id,
          body: customerBody
        });
        setCustomer(customerObject);
      } else {
        console.error('Could not find customer id', customer.id);
      }
    } catch (e) {
      if (!axios.isCancel(e)) enqueueSnackbar(t('error.edit_address'), {
        variant: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    changeAddress
  };
}